export const WidgetStatus = Object.freeze({
  ON: 'ON',
  OFF: 'OFF',
  AWAY: 'AWAY',
})

export const WidgetMode = Object.freeze({
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
})



// WEBPACK FOOTER //
// ./src/scripts/constants/EmbedConfigurationConstants.js